import AppDownloadQRUpsell from './AppDownloadQRUpsell';

export default AppDownloadQRUpsell;
